module.exports = __webpack_public_path__ + "media/images/common/header/sub_mail-5a6ec8e1b6020eb5cdfa1d1ee16794c0.svg";